<template>
  <el-table :data="orders" header-row-class-name="table-header">
    <div slot="empty" class="el-table__empty-text">暫無資料</div>

    <el-table-column prop="orderStatus" label="狀態" width="100px">
      <template slot-scope="scope">
        <div :class="getOrderStatusBadgeType(scope.row.orderStatus)">
          {{ defaultOption.orderStatusLookup[scope.row.orderStatus] }}
        </div>
      </template>
    </el-table-column>
    <!--    <el-table-column prop="orderId" label="編號"></el-table-column>-->
    <el-table-column prop="estimateDate" label="日期"></el-table-column>
    <el-table-column prop="estimateTime" label="時間">
      <template slot-scope="scope">
        <span style="font-size: 20px; font-weight: bold">
          {{ $moment(scope.row.estimateTime, 'HH:mm').format('HH:mm') }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="地址" width="250px">
      <template slot-scope="scope">
        <div>{{ scope.row.onLocation }}</div>
        <div>{{ scope.row.offLocation }}</div>
      </template>
    </el-table-column>
    <el-table-column label="乘客">
      <template slot-scope="scope">
        <div>{{ scope.row.userName }}</div>
        <div>{{ scope.row.contactNumber }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="deliveryMethod" label="派單方式">
      <template slot-scope="scope">
        <div
          v-if="scope.row.deliveryMethod === 0"
          class="status-badge status-badge__success"
        >
          就醫 {{ scope.row.licenseNumber }}
        </div>
        <div v-else class="status-badge status-badge__primary">
          社區 {{ scope.row.licenseNumber }}
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="driverName" label="司機"></el-table-column>
    <el-table-column prop="subsidyMethod" label="補助方式">
      <template slot-scope="scope">
        <div
          v-if="scope.row.subsidyMethod === 0"
          class="status-badge status-badge__primary"
        >
          就醫 {{ scope.row.licenseNumber }}
        </div>
        <div
          v-else-if="scope.row.subsidyMethod === 1"
          class="status-badge status-badge__success"
        >
          社區 {{ scope.row.licenseNumber }}
        </div>
        <div v-else-if="scope.row.subsidyMethod === 2" class="status-badge">
          博愛卡
        </div>
        <div
          v-else-if="!scope.row.subsidyMethod"
          class="status-badge status-badge__danger"
        >
          無
        </div>
        <div v-else class="status-badge">
          {{ defaultOption.subsidyMethodLookup[scope.row.subsidyMethod] }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="自付比例">
      <template slot-scope="scope">
        {{
          scope.row.payOwnselfProportion
            ? `${scope.row.payOwnselfProportion}%`
            : '無'
        }}
      </template>
    </el-table-column>
    <el-table-column label="跳錶金額">
      <template slot-scope="scope">
        跳 NT {{ scope.row.metreFare || 0 }}
      </template>
    </el-table-column>
    <el-table-column label="補助/實收">
      <template slot-scope="scope">
        <div>補 NT {{ scope.row.subsidyFare || 0 }}</div>
        <div>實 NT {{ scope.row.actualFare || 0 }}</div>
      </template>
    </el-table-column>

    <el-table-column label="動作" width="80px">
      <template slot-scope="scope">
        <router-link
          :to="{
            name: 'longTermOrderDetail',
            params: { orderId: scope.row.orderId },
          }"
        >
          <el-button
            type="primary"
            size="mini"
            round
            plain
            style="padding-top: 1px; padding-bottom: 1px"
          >
            檢視
          </el-button>
        </router-link>
        <router-link
          v-if="scope.row.orderStatus !== 5"
          :to="{
            name: 'editLongTermOrderForm',
            params: { orderId: scope.row.orderId },
          }"
        >
          <el-button
            type="danger"
            size="mini"
            round
            plain
            style="padding-top: 1px; padding-bottom: 1px; margin-top: 5px"
          >
            編輯
          </el-button>
        </router-link>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { defaultOption } from './defaultOption'

export default {
  props: {
    orders: Array,
  },
  data() {
    return { defaultOption }
  },
  methods: {
    getOrderStatusBadgeType: (state) => {
      let badgeType = ''
      switch (state) {
        case 0:
        case 1:
          badgeType = 'success'
          break
        case 2:
        case 3:
          badgeType = 'primary'
          break
        // case 7: //即將載客
        //   return 'warning'
        // case 8: //逾期
        //   return 'danger'
        case 4:
        case 5:
        default:
          badgeType = ''
      }

      return `status-badge status-badge__${badgeType}`
    },
  },
}
</script>

<style scoped>
.table-header > th,
.table-header > tr {
  font-weight: 400;
  background: #eee !important;
}
.status-badge {
  border: 2px solid;
  padding: 4px 8px;
  text-align: center;
  width: 100%;
  color: #606266;
  border-color: #606266;
  border-radius: 3px;
}
.status-badge__success {
  color: #67c23a;
  border-color: #67c23a;
}
.status-badge__primary {
  color: #00c0ef;
  border-color: #00c0ef;
}
.status-badge__warning {
  color: #f39c12;
  border-color: #f39c12;
}
.status-badge__danger {
  color: #f56954;
  border-color: #f56954;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/_NormalOrderList.vue